<template>
  <el-page-header
    :content="isEdit ? '编辑轮播图' : '新增轮播图'"
    @back="goBack"
  />
  <div class="form-box">
    <el-form
      ref="formRef"
      :model="formData"
      :rules="rules"
      label-width="120px"
      class="demo-formData"
      :size="formSize"
    >
      <el-form-item label="关联文章" prop="ArticleTitle">
        <!-- <el-input v-model="formData.ArticleContent" /> -->
        <el-autocomplete
          value-key="label"
          v-model="formData.ArticleTitle"
          :fetch-suggestions="querySearch"
          :trigger-on-focus="false"
          clearable
          class="input-w500"
          placeholder=""
          @select="handleSelect"
        />
      </el-form-item>

      <el-form-item label="轮播标题" prop="FTitle">
        <el-input class="input-w500" v-model="formData.FTitle" />
      </el-form-item>

      <el-form-item label="轮播图片" prop="FPic">
        <!-- <el-input v-model="formData.BigPic" /> -->

        <el-upload
          ref="uploadImage"
          :limit="1"
          :action="BASE_HOST + 'v1/cms/upload/'"
          :data="{ module: 'player' }"
          :headers="{
            // 'Content-Type': 'multipart/form-data'
          }"
          :file-list="fileList"
          :on-success="fileUploadSuccess"
          list-type="picture-card"
          :auto-upload="true"
          :on-exceed="handleExceed"
        >
          <!-- {{ fileList }} -->
          <el-icon><Plus /></el-icon>

          <template #file="{ file }">
            <div>
              <img
                class="el-upload-list__item-thumbnail"
                :src="file.url"
                alt=""
              />
              <span class="el-upload-list__item-actions">
                <!-- <el-button @click="showEditImage">裁剪</el-button> -->

                <span
                  class="el-upload-list__item-preview"
                  @click="showEditImage"
                >
                  <el-icon><Scissor /></el-icon>
                </span>

                <span
                  class="el-upload-list__item-preview"
                  @click="handlePictureCardPreview(file)"
                >
                  <el-icon><zoom-in /></el-icon>
                </span>
                <!-- <span
                  v-if="!disabled"
                  class="el-upload-list__item-delete"
                  @click="handleDownload(file)"
                >
                  <el-icon><Download /></el-icon>
                </span> -->
                <span
                  class="el-upload-list__item-delete"
                  @click="handleRemove(file)"
                >
                  <el-icon><Delete /></el-icon>
                </span>
              </span>
            </div>
          </template>
        </el-upload>
        <el-dialog
          v-model="editImage"
          title="图片裁剪"
          :before-close="closeEditImage"
        >
          <!--  imgFile="http://49.5.9.35:48095/sxdzTest03/SXDZ/data/img/icon_monitor.png"  -->
          <CropperComponent
            @closeCropper="closeCropper"
            @upload="imageEdit"
            :imgFile="BASE_HOST + 'v1/images/' + formData.FPic"
          ></CropperComponent>
        </el-dialog>

        <el-dialog v-model="previewImageDialog">
          <el-image fit="cover" :src="dialogImageUrl" alt="Preview Image" />
        </el-dialog>
      </el-form-item>

      <el-form-item>
        <el-button type="primary" v-if="!isEdit" @click="submitForm(formRef)"
          >保存</el-button
        >
        <el-button type="primary" v-else @click="submitForm(formRef)"
          >更新</el-button
        >
        <el-button @click="goBack">返回</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script setup>
import '@wangeditor/editor/dist/css/style.css' // 引入 css
import { BASE_HOST } from '../../../utils/axios'
import { onBeforeUnmount, ref, shallowRef, reactive } from 'vue'
import CropperComponent from '../../../components/cropper-component.vue'
// import imgpath from '../../../assets/img/1268371038.jpg'
import { Delete, Plus, ZoomIn, Scissor } from '@element-plus/icons-vue'
import ModuleType from '../../../data/type'
import { useRoute, useRouter } from 'vue-router'
import { getSearch, putPlayer, postPlayer, uploadImg } from '../../../apis'
import { ElMessage, genFileId } from 'element-plus'
const formRef = ref()
const isEdit = ref(false)
const formSize = ref('default')
const route = useRoute()
const router = useRouter()
const fileList = ref([])
const uploadImage = ref()
const previewImageDialog = ref(false)
const dialogImageUrl = ref('')
const editImage = ref(false)
const formData = reactive({
  FUrl: '',
  ArticleTitle: '', // 暂时存储
  FTitle: '',
  FState: 1,
  FPic: '',
  FSpic: '',
  FAdduser: 'admin',
  FDescription: '',
  IsProduct: 0
  // IsProduct: 0
})

const rules = reactive({
  FTitle: [
    {
      required: true,
      message: '请输入标题',
      trigger: 'blur'
    }
  ],
  FPic: [
    {
      required: true,
      message: '请上传轮播图',
      trigger: 'blur'
    }
  ]
})

const id = route.query.id
const closeEditImage = () => {
  editImage.value = false
}

const showEditImage = () => {
  editImage.value = true
}
const querySearch = (key, cb) => {
  getSearch({ keys: key.replace(/\s/g, ','), size: 40 }).then((res) => {
    let arr = []
    if (res.data.data) {
      arr = res.data.data.map((item) => {
        item.label = ModuleType[item.ModuleID].name + ' : ' + item.ArticleTitle
        item.value = item.ArticleTitle
        //  ModuleType[v.ModuleID].name + ':' +
        return item
      })
    }

    cb(arr)

    // console.log(res.data.data, 123451)
  })
}
const closeCropper = () => {
  editImage.value = false
}
const imageEdit = (base64) => {
  uploadImg({
    file: base64,
    module: 'player'
  }).then((res) => {
    console.log(res, 13)
    formData.FPic = res.data.data.ImgPath
    fileList.value = [
      {
        name: 'image',
        url: BASE_HOST + 'v1/images/' + res.data.data.ImgPath
      }
    ]
  })

  editImage.value = false
}
const handleSelect = (v) => {
  console.log(v)
  formData.FUrl = v.Id + ''
  formData.FTitle = v.ArticleTitle
  formData.IsProduct = v.ModuleID

  // if (ModuleType[v.ModuleID]) {
  // }

  if (!formData.FPic) {
    formData.FPic = v.BigPic || v.SmallPic
    fileList.value = [
      {
        name: 'image',
        url: BASE_HOST + 'v1/images/' + formData.FPic
      }
    ]
  }

  // uploadImage
}
const getData = () => {
  // getArtistsDetail(id).then((res) => {
  //   console.log(123, res)
  //   for (const key in res.data.data) {
  //     if (Object.hasOwnProperty.call(formData, key)) {
  //       const element = res.data.data[key]
  //       formData[key] = element
  //     }
  //   }
  //   if (res.data.data.FPic) {
  //     fileList.value = [
  //       {
  //         name: 'artists-image',
  //         url: BASE_HOST + 'v1/images/' + res.data.data.FPic
  //       }
  //     ]
  //   }
  //   // formData
  // })
}
if (id) {
  // 如果有 id 就是编辑模式
  isEdit.value = true
  getData()
}
const handleRemove = (file) => {
  console.log(file)
  uploadImage.value.clearFiles()
  // formData.ProductSpic = ''
  formData.FPic = ''
}

const handlePictureCardPreview = (file) => {
  dialogImageUrl.value = file.url
  previewImageDialog.value = true
}
const fileUploadSuccess = (returnData) => {
  // 文件上传成功
  console.log(returnData.data.ImgPath, '文件上传成功')

  // setWatermark({
  //   filepath: returnData.data.ImgPath,
  //   small: 1
  // }).then((res) => {
  //   console.log(res, 1233)

  // formData.ProductSpic = res.data.data.SmallPath
  formData.FPic = returnData.data.ImgPath
  // })
}
const handleExceed = (files) => {
  uploadImage.value.clearFiles()
  const file = files[0]
  file.uid = genFileId()
  console.log(file, 1233)

  uploadImage.value.handleStart(file)
  uploadImage.value.submit()
}

// 编辑器实例，必须用 shallowRef
const editorRef = shallowRef()

// 组件销毁时，也及时销毁编辑器
onBeforeUnmount(() => {
  const editor = editorRef.value
  if (editor == null) return
  editor.destroy()
})

// console.log(valueHtml.value, 999)

const submitForm = async (formEl) => {
  console.log(formEl, 123)
  if (!formEl) return
  await formEl.validate((valid, fields) => {
    if (valid) {
      console.log('submit!', formData, formEl)

      if (isEdit.value) {
        // 更新数据
        putPlayer(formData, id).then((res) => {
          console.log(res)
          ElMessage({
            message: '更新成功成功！',
            type: 'success'
          })

          router.go(-1)
        })
      } else {
        // 上传数据
        postPlayer(formData).then((res) => {
          console.log(res)
          if (res.data.code === 201) {
            ElMessage({
              message: '创建成功！',
              type: 'success'
            })
            router.go(-1)
          } else {
            ElMessage({
              message: '创建失败请检查参数！',
              type: 'error'
            })
          }
        })
      }
    } else {
      console.log('error submit!', fields)
    }
  })
}

const goBack = () => {
  router.push({ name: 'adminBanner' })
}
</script>

<style lang="scss" scoped>
.form-box {
  margin: 20px auto;
}
</style>
